import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AgendamentoDespesaInserirComponent } from './agendamento-despesa-inserir.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: '', component: AgendamentoDespesaInserirComponent }
    ])],
    exports: [RouterModule]
})
export class AgendamentoDespesaInserirRoutingModule { }
